import i18n from '@/lang/index'

export default [
  {
    element: '.driver-item-home',
    popover: {
      title: i18n.t('public.alarm_switch'),
      description: i18n.t('public.go_home')
    },
    onHighlightStarted (element) {
      element.click()
    }
  },
  {
    element: '.driver-item-alarm-switch',
    popover: {
      title: i18n.t('public.alarm_switch'),
      description: `${i18n.t('public.click_open_close_alarm')} <br /> 
      ${i18n.t('public.alarm_color_title_1')}:<br />
      ${i18n.t('public.alarm_color_red')}<br />
      ${i18n.t('public.alarm_color_green')}<br />
      ${i18n.t('public.alarm_color_gray')}`,
      operate: {
        openMenu: 'business'
      }
    }
  },
  {
    permission: ['viewIncubator'],
    element: '.driver-item-incubator',
    popover: {
      title: i18n.t('public.alarm_switch'),
      description: i18n.t('public.Carrier_list_desc')
    },
    onHighlightStarted (element) {
      element.click()
    }
  },
  {
    permission: ['viewIncubator'],
    element: '.driver-item-alarm-switch',
    popover: {
      title: i18n.t('public.alarm_switch'),
      description: `${i18n.t('public.click_open_close_alarm')} <br /> 
        ${i18n.t('public.alarm_color_title_1')}:<br />
        ${i18n.t('public.alarm_color_red')}<br />
        ${i18n.t('public.alarm_color_green')}<br />
        ${i18n.t('public.alarm_color_gray')}`
    }
  }
]
